/**
 * Fixes "McLean" text in overlines.
 * Finds any variation of "mclean" in .has-overline-font-size elements
 * and replaces it with properly cased "McLean", removing text-transform.
 */
const mcleanTextFix = () => {
	const overlines = document.querySelectorAll('.has-overline-font-size');

	overlines.forEach((el) => {
		const regex = /mclean/gi;

		if (regex.test(el.textContent)) {
			el.innerHTML = el.innerHTML.replace(
				regex,
				'<span style="text-transform:none">McLEAN</span>'
			);
		}
	});
};

export default mcleanTextFix;
